module.exports = __webpack_public_path__ + "static/media/coil-large.8e008099.svg";